


















import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { add } from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import firebase from 'firebase'
import { VueEditor } from 'vue2-editor'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import MessageStore from '../../store/modules/messages'
import CDatePicker from '../inputs/CDatePicker.vue'
import { rdb } from '../../firebase/init'
import Notification from './Notification.vue'
import {
  MessageType, CommentType, NotificationType, NotificationCollection,
} from '../../types'

@Component({
  components: {
    Notification,
    VueEditor,
    CDatePicker,
  },
})

export default class NewNotification extends Mixins(MainMixin) {
  // @Prop() data!:NotificationType[]
  data:NotificationType =
    {
      title: '',
      user: this.$store.getters.uid,
      location: this.$store.getters.location,
      message: '',
      expires: '',
      push: false,
      created: new Date(),
      comments: [],
    }

  showDate:boolean = false

  loading = false

  selectedDate = ''

  async addNotification() {
    this.loading = true
    this.data.created = new Date()
    this.data.expires = this.showDate ? '' : this.selectedDate
    await add(NotificationCollection, this.data)
    this.loading = false
    this.$toast.success('Notification Added!')
    this.close()
  }

  @Emit()
  close() {
    return true
  }
}

